import { Component, Inject, Input, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { CommonService } from '@/app/shared/services/common.service';
import { CartService } from '@/app/shared/services/cart.service';

import { Cart } from '@/app/shared/interface/cart.interface';
import { Option } from '@/app/shared/interface/common.interface';
import { Product, StockStatus } from '@/app/shared/interface/product.interface';
import { ToastrService } from 'ngx-toastr';
import { LabelQueryString } from '../../filter';
import { AuthService } from '../../services/auth.service';
import { Voucher } from '../../interface/voucher.interface';
import { ForgotPasswordModalComponent } from '../forgot-password-modal/forgot-password-modal.component';
import { LoginModalComponent } from '../login-modal/login-modal.component';
import { RegistryModalComponent } from '../registry-modal/registry-modal.component';
import { ListBanners } from '../../interface/banner.interface';
import { VoucherDetailModalComponent } from '../modal/voucher-modal/voucher-detail-modal/voucher-detail-modal.component';
import { useSafeTimeout } from '../../ssr-util';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-product-contain',
  templateUrl: './product-contain.component.html',
  styleUrls: ['./product-contain.component.scss'],
})
export class ProductContainComponent {

  @ViewChild("loginModal") LoginModal: LoginModalComponent;
  @ViewChild("registryModal") RegistryModal: RegistryModalComponent;
  @ViewChild("forgotPasswordModal") ForgotPasswordModal: ForgotPasswordModalComponent;
  @ViewChild("detailModal", { static: false }) detailModal: VoucherDetailModalComponent;

  @Input() product: Product;
  @Input() option: Option | null;
  @Input() owlCar: any;
  @Input() isAuthenticated: boolean = false;
  @Input() vouchers: Voucher[] = [];
  @Input() productSuggestions: Product[] = [];
  @Input() productVouchers: Voucher[] = [];
  @Input() selectedVoucherCode: string[] = [];
  @Input() productBanner: ListBanners | undefined;
  @Input() productPolicy: any[] = [];

  public cart: Cart;
  public isAccountActivated: boolean = false;
  public ordersCount: number = 10;
  public viewsCount: number = 30;
  public labelQueryString: LabelQueryString = new LabelQueryString();
  public countsInterval: any;
  modalVoucherOpen: boolean = false;
  selectedVoucher: Voucher;
  Math = Math;
  public tempporarilyUnavailable: StockStatus.TempporarilyUnavailable;

  body = {
    productId: 0,
    quantity: 1
  }

  private safeTimeout = useSafeTimeout();

  isBrowser: boolean = false;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private cartService: CartService,
    private toastService: ToastrService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    }
    this.isAuthenticated = this.authService.isAuthenticated();
    this.isAccountActivated = this.authService.isAccountActivated();

    if (this.product) {
      this.body.productId = this.product.productID;
      this.product.progressLabel = this.commonService.getProgressLabel(this.product);
    }
  }

  checkStockAvailable() {

  }

  addToCart(item: any) {
    if (this.body.quantity == 0) {
      this.toastService.warning("Xin nhập số lượng", "", { positionClass: "toast-top-right" });
      return;
    }
    this.body.productId = item.productID;

    for (let cartItem of this.cart.items) {
      if (cartItem.productID == item.productID) {
        this.body.quantity = cartItem.quantity + 1;
        break;
      }
    }
    this.cartService.updateCart(JSON.stringify(this.body)).subscribe({
      next: (res: any) => {
        this.commonService.setCart(res);
        this.toastService.success('Đã cập nhật giỏ hàng!', "", { positionClass: "toast-top-right" });
      },
      error: (error: any) => {
        console.log(error);
        this.toastService.warning('Lỗi cập nhật giỏ hàng!', "", { positionClass: "toast-top-right" });
      }
    });
  }

  buyNow(product: any) {
    if (product) {

    }
  }

  addToWishlist(id: number) {

  }

  addToCompare(id: number) {

  }

  ngOnDestroy() {
    // Clear the interval when the component is destroyed
    if (this.countsInterval) {
      clearInterval(this.countsInterval);
    }
  }

  redirectPage(slug: string) {
    this.router.navigate(['/product'], {
      queryParams: {
        label: slug
      },
      queryParamsHandling: 'merge' // optional
    });
  }

  openRegistryModal(event: any) {
    if (event) {
      this.RegistryModal.openModal();
    }
  }

  openLoginModal(event: any) {
    if (event) {
      this.LoginModal.openModal();
    }
  }

  openForgotPasswordModal(event: any) {
    if (event) {
      this.ForgotPasswordModal.openModal();
    }
  }

  closeModalVoucher() {
    this.modalVoucherOpen = false;
  }

  async selectVoucher(voucher: any) {
    const matchedVoucher = this.vouchers.find((v: Voucher) => {
      return v.code === voucher.voucherCode;
    });
    if (matchedVoucher) {
      this.selectedVoucher = matchedVoucher;
      if (!this.modalVoucherOpen) {
      this.modalVoucherOpen = true;
      this.safeTimeout(() => {
        this.detailModal.openModal();
      }, 10);
    }
    }
  }

  hasTag(slug: string): boolean {
    return this.product?.labels?.some((l) => l.slug === slug);
  }

  tagCount(): number {
    let count = 0;
    if (this.hasTag('san-pham-doc-quyen')) count++;
    if (this.isPromotionalProduct(this.product)) count++;
    return count;
  }

  isPromotionalProduct(item: any): boolean {
    if (!item || !this.vouchers?.length) return false;
    const productLabelSlugs = item.labels?.map((l: any) => l.slug) ?? [];
    const productSku = String(item?.sku ?? '');
    const categoryIds = item.categories?.map((c: any) => c.categoryId) ?? [];

    for (const voucher of this.vouchers) {
      const condition = voucher.voucherCondition; // kiểm tra cả 2 khả năng
      if (!condition) continue;

      const labelQtyConditions =
        condition.ApplicableLabelQuantity ??
        condition.applicableLabelQuantity ??
        [];
      for (const cond of labelQtyConditions) {
        const condLabels = Array.isArray(cond?.labels)
          ? cond.labels
          : cond?.labels
            ? [cond.labels]
            : [];
        if (
          condLabels.some((slug: string) => productLabelSlugs.includes(slug))
        ) {
          return true;
        }
      }

      const applicableLabels =
        condition.ApplicableLabels ?? condition.applicableLabels ?? [];
      if (
        applicableLabels.some((slug: string) =>
          productLabelSlugs.includes(slug),
        )
      ) {
        return true;
      }

      const productQtyConditions = condition.productQuantityConditions ?? [];
      if (
        productQtyConditions.some(
          (cond: any) => String(cond?.sku ?? '') === productSku,
        )
      ) {
        return true;
      }

      const applicableCategoryIds =
        condition.ApplicableCategoryIds ??
        condition.applicableCategoryIds ??
        [];
      if (
        applicableCategoryIds.some((cid: string) => categoryIds.includes(cid))
      ) {
        return true;
      }

      const categoryQtyConditions =
        condition.ApplicableCategoryQuantity ??
        condition.applicableCategoryQuantity ??
        [];
      if (
        categoryQtyConditions.some((cond: any) =>
          categoryIds.includes(cond.categoryId),
        )
      ) {
        return true;
      }
    }

    return false;
  }
}
